export var CustomReportsError;
(function (CustomReportsError) {
})(CustomReportsError || (CustomReportsError = {}));
var CustomReportsRequest = /** @class */ (function () {
    function CustomReportsRequest(query) {
        this.knownErrorCodes = Object.values(CustomReportsError);
        this.method = 'get';
        var customReportsQuery = new URLSearchParams([
            ['page', String(query.page)],
            ['perPage', String(query.perPage)],
            ['archived', String(query.archived)],
        ]);
        this.path = "my/customized-reports?".concat(String(customReportsQuery));
    }
    return CustomReportsRequest;
}());
export { CustomReportsRequest };
